// Must match OauthThrottleSetting::MODES.
const throttleModeOptions = [
  { id: 'off', label: 'Off: no counting', value: 'off' },
  {
    id: 'log_only',
    label: 'Log only: count and log, never 429',
    value: 'log_only',
  },
  { id: 'enforced', label: 'Enforced: 429 over the limit', value: 'enforced' },
];

export default throttleModeOptions;
